"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalCspType = void 0;
var ExternalCspType;
(function (ExternalCspType) {
    ExternalCspType["IMG_SRC"] = "img-src";
    ExternalCspType["MEDIA_SRC"] = "media-src";
    ExternalCspType["SCRIPT_SRC"] = "script-src";
    ExternalCspType["STYLE_SRC"] = "style-src";
    ExternalCspType["CONNECT_SRC"] = "connect-src";
    ExternalCspType["FONT_SRC"] = "font-src";
    ExternalCspType["FRAME_SRC"] = "frame-src";
})(ExternalCspType = exports.ExternalCspType || (exports.ExternalCspType = {}));
